import { Injectable } from '@angular/core';
import { MaintenanceType } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class FcMaintenanceTypesOutlinedSelectService {
  constructor(private readonly apollo: Apollo) {}

  public async getMaintenanceTypesBySegmentId(segmentId: string): Promise<Partial<MaintenanceType>[]> {
    return this.apollo
      .query({
        query: gql`
          query segment($id: ID!) {
            segment(id: $id) {
              maintenanceTypes {
                id
                name
              }
            }
          }
        `,
        variables: {
          id: segmentId
        }
      })
      .toPromise()
      .then((result) => result.data['segment']['maintenanceTypes']);
  }

  public async getPaginatedMaintenanceTypes(): Promise<Partial<MaintenanceType>[]> {
    return this.apollo
      .query({
        query: gql`
          query searchMaintenanceTypes($where: MaintenanceTypeWhereInput) {
            maintenanceTypes(where: $where, orderBy: name_asc, limit: 100, offset: 0) {
              items {
                id
                name
              }
            }
          }
        `,
        variables: {
          where: {
            archived: false
          }
        }
      })
      .toPromise()
      .then((result) => result.data['maintenanceTypes']['items']);
  }
}
